













































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import NavegacionModalCrud from '@/reusable/Mantenedor/NavegacionModalCrud.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import EquiposyPerifericosCrm from '@/pantallas/Conecta/Add/modal-altas/EquiposyPerifericosCrm.vue';
import ActividadPreparacion from '@/pantallas/Conecta/Add/modal-altas/ActividadPreparacion.vue';
import Activos from '@/pantallas/Conecta/Add/modal-altas/Activos.vue';
import Actividades from '@/pantallas/Conecta/Add/modal-altas/Actividades.vue';
import ActividadDespacho from '@/pantallas/Conecta/Add/modal-altas/ActividadDespacio.vue';
import DetalleVenta from '@/pantallas/Conecta/Add/modal-altas/DetalleVenta.vue';
import OrdenesServicio from '@/pantallas/Conecta/Add/modal-altas/OrdenesServicio.vue';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    NavegacionModalCrud,
    FormFieldsContainer,
    DatePicker,
    EquiposyPerifericosCrm,
    ActividadPreparacion,
    Activos,
    Actividades,
    ActividadDespacho,
    DetalleVenta,
    OrdenesServicio,
  },
})
export default class ModalVerDetalleCrm extends Vue {
  @Prop({ default: false }) show: boolean;
  @Prop({ default: '' }) NombreAlta: string;
  @Prop({ default: '' }) AltaCrm_Seleccionada: any;
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();
  tabs: any = null;
  showInfo: boolean = true;
  Alta_Seleccionada: any;

  created() {
    this.Alta_Seleccionada = this.AltaCrm_Seleccionada;
  }

  mounted() {}

  handleCerrar() {
    this.Alta_Seleccionada = {};
    this.$emit('cerrar');
  }

  handleInfoGeneral() {
    this.showInfo = true;
  }

  pasoActivoIndex = 1;
  pasos = {
    informacionGeneral: {
      accion: 'Crear - Información General',
      visible: true,
      step: 1,
    },
  };
}
